import { Segment } from '../domain/segments';

export function getMaxWidthForWaveform(segments: readonly Segment[]) {
  return (
    segments.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.waveform.length;
    }, 0) -
    segments.length * 2
  );
}
